<div
	class="company-logo"
	[style.width]="logoWidth"
	[style.height]="logoHeight"
>
	@if (logoSrc) {
		<img
			class="logo"
			[src]="logoSrc"
			[alt]="logoAlt"
			[style.width]="logoWidth"
			[style.height]="logoHeight"
		/>
	} @else {
		<div class="fallback">{{ symbol }}</div>
	}
</div>
